import React from 'react';

const EXPERIENCES = [
  { date: 'June 2023 – Present', role: 'Cofounder and CTO', company: 'Contour (YC S23)', current: true },
  { date: 'October – March 2023', role: 'Data Analyst', company: 'Rocketship.VC' },
  { date: 'October – July 2022', role: 'Software Engineer', company: 'Hypeshot' },
  { date: 'June – September 2021', role: 'Software Engineer (Part-time)', company: 'Hypeshot' },
  { date: 'June – September 2020', role: 'Software Engineering Intern', company: 'Amazon Web Services' },
  { date: 'January – March 2020', role: 'AI Research Fellow', company: 'UnifyID' },
  { date: 'June – September 2019', role: 'Machine Learning Intern', company: 'Polarr' },
  { date: 'June – August 2018', role: 'Software Engineering Intern', company: 'AmerisourceBergen Co. (now Cencora)' },
];

const Work = () => (
  <div className="page page--narrow">
    <header className="page-header">
      <h1 className="page-title">Work</h1>
      <p className="page-lead">
        Where I've spent my time, most recent first.
      </p>
    </header>

    <ol className="work-list">
      {EXPERIENCES.map((exp) => (
        <li key={`${exp.date}-${exp.role}`} className="work-row">
          <span className="work-date">
            {exp.current && <span className="now-dot" aria-hidden="true" />}
            {exp.date}
          </span>
          <span>
            <div className="work-role">{exp.role}</div>
            <div className="work-company">{exp.company}</div>
          </span>
        </li>
      ))}
    </ol>
  </div>
);

export default Work;
